import { render, staticRenderFns } from "./EditUserGameRanks.vue?vue&type=template&id=98d200a6&scoped=true&"
import script from "./EditUserGameRanks.vue?vue&type=script&lang=ts&"
export * from "./EditUserGameRanks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d200a6",
  null
  
)

export default component.exports